import { apiService } from './api';
import { ApiResponse, Sale } from '../types';

export interface DashboardSummary {
  total_stock_items: number;
  remaining_stock: number;
  low_stock_count: number;
  out_of_stock_count: number;
  sold_today: number;
  today_revenue: number;
  monthly_revenue: number;
  monthly_profit: number;
  monthly_is_profit: boolean;
  recent_sales: Sale[];
}

export const dashboardService = {
  async getSummary(): Promise<ApiResponse<DashboardSummary>> {
    return apiService.get('/api/dashboard/summary');
  },
};

